import React, { useCallback, useRef } from 'react';
import { Form } from '@unform/web';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import { FormHandles } from '@unform/core';

import getValidationErros from '~/utils/getValidationsErrors';
import api from '~/services/api';

import { Container } from './styles';
import ButtonBack from '~/components/ButtonBack';
import Input from '~/components/Input';
import InputMask from '~/components/InputMask';

interface IFormData {
  email: string;
  document: string;
}

const RecoverPassword: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const [errorEmailOrDoc, setErrorEmailOrDoc] = React.useState('');

  const handleSubmit = useCallback(async (data: IFormData) => {
    try {
      formRef.current?.setErrors({});

      const schema = Yup.object()
        .shape({
          email: Yup.string().email('Informe um e-mail válido'),
          document: Yup.string(),
        })
        .test('email-or-document', 'Preencha o e-mail ou o CPF', (value) => {
          if (!value?.email && !value?.document) {
            setErrorEmailOrDoc('Preencha o e-mail ou o CPF');
            return false;
          }

          return !!(value?.email || value?.document);
        });

      await schema.validate(data, {
        abortEarly: false,
      });

      const response = await api.post(
        'users/sessions/forgot-password',
        {
          email: data.email || undefined,
          document: data.document || undefined,
        },
        {
          params: {
            environment: 'Atleta',
          },
        }
      );

      Swal.fire(
        'Tudo certo!',
        `Um e-mail foi enviado para ${
          response.data.email ? `${response.data.email} para` : 'a'
        } recuperação da sua conta`,
        'success'
      );
    } catch (error) {
      if (error instanceof Yup.ValidationError) {
        const errors = getValidationErros(error);
        formRef.current?.setErrors(errors);
      } else {
        Swal.fire('Oops...', 'Ocorreu um erro tente novamente', 'error');
      }
    }
  }, []);

  return (
    <Container>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-11 text-center pt-3">
            <ButtonBack className="mt-3" />
            <div className="banner my-3" />
            <h1 className="text-start mb-3">Recuperando senha</h1>
            <p>
              Para alterar a senha, favor preencher com o e-mail ou o seu CPF
              para que possamos enviar uma mensagem com um link para geração de
              nova senha.
            </p>
          </div>

          <div className="col-11 px-3">
            <Form
              ref={formRef}
              onSubmit={handleSubmit}
              className="d-flex flex-column pb-3"
            >
              <div className="">
                <span>E-mail</span>

                <Input
                  name="email"
                  type="email"
                  className="bd-input"
                  onChange={(e) => {
                    if (e.target.value) {
                      setErrorEmailOrDoc('');
                    }
                  }}
                />
              </div>
              <p className="text-center my-2">ou</p>
              <div className="mb-2">
                <span>CPF</span>
                <InputMask
                  kind="cpf"
                  name="document"
                  className="form-control rounded height"
                  onChange={() => setErrorEmailOrDoc('')}
                />
              </div>

              {errorEmailOrDoc && (
                <p className="text-danger text-center">{errorEmailOrDoc}</p>
              )}
              <button
                type="submit"
                className="btn btn-login h6 fw-normal py-2 mt-4"
              >
                Continuar
              </button>
            </Form>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default RecoverPassword;
